import { Link } from "react-router-dom";
import stylecycleLogo from "@/assets/stylecycle-logo.avif";
import { Mail, MessageCircle } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-charcoal text-porcelain">
      <div className="container-wide section-padding py-16 md:py-20 pb-24 md:pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={stylecycleLogo} alt="StyleCycle" className="h-12 w-auto" />
              <h3 className="font-heading text-3xl font-bold">StyleCycle</h3>
            </div>
            <p className="text-sage-soft/80 text-sm leading-relaxed mb-6">
              Sourcing with trust and transparency. Your dependable global partner for fashion and lifestyle manufacturing.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-xl font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {["Home", "About Us", "Products", "Services", "Network & Certifications", "Our Clients", "Our Factories"].map((label, i) => {
                const paths = ["/", "/about", "/products", "/services", "/network", "/clientele", "/factories"];
                return (
                  <li key={label}>
                    <Link to={paths[i]} className="text-sage-soft/70 hover:text-soft-moss text-sm transition-colors duration-200">
                      {label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xl font-semibold mb-4">Products</h4>
            <ul className="space-y-3">
              {["Knitwear", "Denim & Wovenwear", "Activewear", "Outerwear", "Footwear", "Home Textiles", "Home Décor", "Bags & Luggage"].map((p) => (
                <li key={p}>
                  <Link to="/products" className="text-sage-soft/70 hover:text-soft-moss text-sm transition-colors duration-200">
                    {p}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xl font-semibold mb-4">Contact</h4>
            <div className="space-y-4">
              <a
                href="https://wa.me/8801515201457"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sage-soft/70 hover:text-soft-moss text-sm transition-colors duration-200"
              >
                <MessageCircle size={16} /> +880 1515-201457 (Ahsan)
              </a>
              <a
                href="https://wa.me/8801706311191"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sage-soft/70 hover:text-soft-moss text-sm transition-colors duration-200"
              >
                <MessageCircle size={16} /> +880 1706-311191 (Subhasis)
              </a>
              <a href="mailto:sub@stylecycle.ai" className="flex items-center gap-3 text-sage-soft/70 hover:text-soft-moss text-sm transition-colors duration-200">
                <Mail size={16} /> sub@stylecycle.ai
              </a>
              <a href="mailto:ahsan@stylecycle.ai" className="flex items-center gap-3 text-sage-soft/70 hover:text-soft-moss text-sm transition-colors duration-200">
                <Mail size={16} /> ahsan@stylecycle.ai
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-forest-moss/30 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sage-soft/90 text-sm space-y-1">
            <p>© {new Date().getFullYear()} StyleCycle Limited. All rights reserved.</p>
            <p>
              Developed by{" "}
              <a
                href="https://devguardian.site"
                target="_blank"
                rel="noopener noreferrer"
                className="text-soft-moss hover:text-sage-soft transition-colors"
              >
                DevGuardian
              </a>
              .
            </p>
          </div>
          <p className="text-sage-soft/90 text-sm">
            Sourcing with Trust & Transparency
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
